<script setup lang="ts">
import BlueButton from "../../components/BlueButton.vue";
import GreetingBlock from "../../components/GreetingBlock.vue";
import { locale } from "../../locale";
import { authState, checkCallExist, commitAuthState } from "../../states/auth";
import GreetingPage from "../templates/GreetingPage.vue";
import InputBox from "../../components/InputBox.vue";
import PreviewVideoNew from "../../components/PreviewVideoNew.vue";
import { roomState } from "../../states/room";
import CopyLinkBtn from "../../components/preview/CopyLinkBtn.vue";
import { nextTick, ref } from "vue";
import { fetcher } from "../../api/fetcher";
import TarifModal from "../../components/modals/TarifModal.vue";
import {
  combineValidators,
  getEmptyFieldValidator,
  getMaxLenValidator,
} from "../../utils/validators";
import ChatRecordsBlock from "../../components/ChatRecordsBlock.vue";
import { setupApprovedSelfData } from "../../states/approveSelfEnterState";
import { transitionEvents } from "../../states/transitions";
import { useRouter } from "vue-router";
import { build_settings } from "../../assets/custom/settings";
import { init } from "../../states/media/state";
import { roomStarted } from "../../states/viewState";

const router = useRouter();
transitionEvents.emit("start");
const isTarifModal = ref(false);

init()

const nameValidator = combineValidators([
  getEmptyFieldValidator(locale.validators.fieldnames.name).validator,
  getMaxLenValidator(600, locale.validators.fieldnames.name).validator,
]);
const input = ref<typeof InputBox | null>(null);
const run = async () => {
  const exist = await checkCallExist();
  if (exist) {
    router.push({
      name: "error",
      params: {
        errtype: "call-exist",
      },
    });
    throw "exist another call";
  }
  authState.displayedName = authState.displayedName.trim();
  await new Promise((resolve) => {
    nextTick(() => resolve(null));
  });
  nameValidator.validator(authState.displayedName);
  if (!nameValidator.state.value) {
    input.value?.shake();
    return;
  }
  await commitAuthState();
  roomStarted.value = true;
  setupApprovedSelfData();
  if (roomState.status !== "Active") {
    try {
      await fetcher.post({
        path: `/room/start/${roomState.id}`,
        payload: {},
      });
    } catch (err) {
      const error = err as { data: { message: string } };
      if (error.data.message === "tariff blocked") {
        isTarifModal.value = true;
      }
    }
  }
};
const copyState = ref(false);
const pushClipboard = () => {
  if (navigator.clipboard.writeText) {
    navigator.clipboard.writeText(window.location.href);
    copyState.value = true;
    setTimeout(() => {
      copyState.value = false;
    }, 5000);
  }
};
</script>
<template>
  <GreetingPage class="create-meeting">
    <div class="dblock-wrapper">
      <GreetingBlock :title="roomState.name">
        <div class="preview-block">
          <PreviewVideoNew />
        </div>
        <InputBox
          ref="input"
          v-model="authState.displayedName"
          :validator="nameValidator.validator"
          :title="locale.youname"
          :placeholder="locale.required"
        />
        <div class="controls">
          <div class="copy-btn-container">
            <CopyLinkBtn :state="copyState" @click="pushClipboard" />
          </div>
          <BlueButton @click="run">{{
            roomState.status === "Active" ? locale.goconnect : locale.runMeeting
          }}</BlueButton>
        </div>
      </GreetingBlock>
      <ChatRecordsBlock v-if="roomState.status === 'Suspended'" />
    </div>
    <TarifModal
      v-if="isTarifModal && !build_settings.disable_tariff_feature"
      :title="locale.tarifStartCallModal.title"
      :text="locale.tarifStartCallModal.text"
      :close-text="locale.tarifStartCallModal.close"
      @close="isTarifModal = false"
    />
    <TarifModal
      v-else-if="isTarifModal && build_settings.disable_tariff_feature"
      :title="locale.tarifDisabledStartCallModal.title"
      :text="locale.tarifDisabledStartCallModal.text"
      :close-text="locale.tarifDisabledStartCallModal.close"
      @close="isTarifModal = false"
    />
  </GreetingPage>
</template>
<style scoped>
.blocked {
  cursor: wait;
}

.blocked * {
  pointer-events: none;
}

.controls {
  padding: 0 12px 0 0;
  display: flex;
  justify-content: space-between;
}

.dblock-wrapper {
  display: flex;
  gap: 24px;
}

.checkbox-wrapper {
  padding: 0 12px;
}

.preview-block {
  padding: 12px;
  display: flex;
  height: 220px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.right {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.copy-btn-container {
  display: flex;
  flex-direction: row-reverse;
  padding-left: 12px;
}
</style>
